import { Box, Flex } from '@welbe/design-system';
import { Actions } from '../Actions/Actions';
import { UsersTable } from '../UsersTable/UsersTable';
import { AddProfileDialog } from './AddProfileDialog/AddProfileDialog';
import { formattedRows } from './Admin.builder';
import { columns } from './Admin.constants';
import { useAdmin } from './Admin.hooks';
import { AdminDialog } from './AdminDialog/AdminDialog';
import { AdminFilters } from './AdminFilters/AdminFilters';

export const Admin = () => {
	const {
		selectedUser,
		setUserModalVisible,
		handleEditUser,
		openModalAddProfile,
		setOpenModalAddProfile,
		data,
		loading,
		totalAmount,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
		filters,
		isUserModalVisible,
		handleToggleUserModal,
	} = useAdmin();

	return (
		<>
			<Box bg="white" p="0 1.25rem 1.25rem" w="100%">
				<Actions
					handleOpenModalAddUser={() => setUserModalVisible(true)}
					handleOpenModalAddProfile={() => setOpenModalAddProfile(true)}
				/>
				<Flex direction="column" gap="12px" w="100%">
					<AdminFilters
						filters={filters}
						onChangeFilters={handleFilters}
						onSearch={handleSearch}
					/>
					<UsersTable
						headers={columns}
						rows={formattedRows(data, handleEditUser)}
						loading={loading}
						currentPage={currentPage}
						totalAmount={totalAmount}
						pageSize={filters.pageSize}
						onPageChange={handleChangePage}
					/>
				</Flex>
			</Box>
			<AdminDialog
				open={isUserModalVisible}
				setOpen={handleToggleUserModal}
				user={selectedUser}
				onSuccess={handleSearch}
			/>
			<AddProfileDialog
				open={openModalAddProfile}
				setOpen={setOpenModalAddProfile}
			/>
		</>
	);
};
